// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebaseConfig :{
    apiKey: "AIzaSyAoJALoIjZ-jc6Td-xEHddiAMTbE8YmMic",
    authDomain: "aao-disruption.firebaseapp.com",
    projectId: "aao-disruption",
    storageBucket: "aao-disruption.firebasestorage.app",
    messagingSenderId: "1044172855290",
    appId: "1:1044172855290:web:4d32d81cee6ac62e47b643"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
